const authApiFactory = (axios) => ({
  authRequest: async (service, storeId, params) =>
    (await axios.get(`/customers/authorization/${service}/callback/${storeId}`, { params })).data,
});

export { authApiFactory };
